/**
 * 供应商管理服务
 * Supplier Service
 */
import api from './api';

export interface ISupplier {
  _id: string;
  name: string;
  address?: string;
  phone?: string;
  remark?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SupplierListResponse {
  success: boolean;
  data: ISupplier[];
  total: number;
}

export interface SupplierResponse {
  success: boolean;
  data: ISupplier;
  created?: boolean;
  message?: string;
}

export interface CreateSupplierData {
  name: string;
  address?: string;
  phone?: string;
  remark?: string;
}

export interface UpdateSupplierData {
  name?: string;
  address?: string;
  phone?: string;
  remark?: string;
}

/**
 * 获取供应商列表（支持模糊搜索和类型过滤）
 */
export const listSuppliers = async (search?: string, limit = 100, type?: 'material' | 'equipment' | 'both'): Promise<SupplierListResponse> => {
  const params: Record<string, any> = { limit };
  if (search && search.trim()) params.search = search.trim();
  if (type) params.type = type;
  const response = await api.get('/suppliers', { params });
  return response as SupplierListResponse;
};

/**
 * 创建供应商（输入即创建语义：名称已存在则返回已有记录）
 */
export const createSupplier = async (data: CreateSupplierData): Promise<SupplierResponse> => {
  const response = await api.post('/suppliers', data);
  return response as SupplierResponse;
};

/**
 * 更新供应商信息
 */
export const updateSupplier = async (id: string, data: UpdateSupplierData): Promise<SupplierResponse> => {
  const response = await api.put(`/suppliers/${id}`, data);
  return response as SupplierResponse;
};

/**
 * 删除供应商
 */
export const deleteSupplier = async (id: string): Promise<{ success: boolean; message: string }> => {
  const response = await api.delete(`/suppliers/${id}`);
  return response as { success: boolean; message: string };
};

export default {
  listSuppliers,
  createSupplier,
  updateSupplier,
  deleteSupplier,
};
